import styled from '@emotion/styled'
import { theme as newTheme } from 'styles/theme/hav-theme'

export const LogoImageStyled = styled.img`
  width: 100%;
  margin-top: 80px;
  margin-bottom: ${newTheme.spacing['2xl']};
  max-width: 150px;
  @media only screen and (max-width: ${newTheme.breakpoints.lg}px) {
    margin-top: ${newTheme.spacing['2xl']};
  }
  @media only screen and (max-width: ${newTheme.breakpoints.md}px) {
    margin-top: 80px;
  }
  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    max-width: 121px;
    margin: ${newTheme.spacing.xm} 0;
    margin-top: ${newTheme.spacing.xl};
  }
`
export const WrapperContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const WrapperTitlePageStyled = styled.div`
  display: flex;
  justify-content: center;
  h1 {
    font-size: ${newTheme.typography.sizes['3xl']};
    font-family: ${newTheme.typography.family.primary};
    font-weight: ${newTheme.typography.weight.lg};
    line-height: normal;

    font-size: 2.25rem;
    text-align: center;
    @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
      max-width: 168px;
      line-height: 33px;
      font-size: 1.375rem;
    }
  }
`
export const ErrorImageStyled = styled.img`
  width: 100%;
  margin: ${newTheme.spacing['2xl']} 0;
  max-width: 517px;
  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    max-width: 234px;
    margin: ${newTheme.spacing.xm} 0;
  }
`
export const WrapperSubTitlePageStyled = styled.div`
  display: flex;
  justify-content: center;
  h2 {
    font-family: ${newTheme.typography.family.primary};
    font-weight: ${newTheme.typography.weight.md};
    line-height: normal;
    font-size: 1.875rem;
    margin: 0 ${newTheme.spacing.xm};
    text-align: center;
    @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
      font-size: 1.125rem;
    }
  }
`
export const WrapperContentTextStyled = styled.p`
  font-family: ${newTheme.typography.family.primary};
  font-size: ${newTheme.typography.sizes.sm};
  line-height: normal;
  font-size: 1rem;
  margin: ${newTheme.spacing.sm} ${newTheme.spacing.xm};
  text-align: center;
  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    text-align: center;
    font-size: 0.875rem;
  }
`
